module.exports = __webpack_public_path__ + "static/media/musicBtn.d9b4cb31.svg";